import React from 'react';
import Hero from '../components/home/Hero';
import ProductGrid from '../components/home/ProductGrid';
import SEO from '../components/common/SEO';

const Home = () => {
  return (
    <>
      <SEO 
        title="Productivity Tools for ADHD & Creators"
        description="Bypass paralysis and kill overwhelm with science-based ADHD productivity tools, Notion templates, and content planners from AlienProduction."
        canonical="/"
      />
      <Hero />
      <ProductGrid />
    </>
  );
};

export default Home;